import React, {useEffect, useRef, useState} from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import {makeInput} from '../util/Forms.js';
import {licenseData, makeLicenseSelection} from '../KairosProducts.js';
import {fields} from './Trainer.js';
import useSubmitCancel from "../util/useSubmitCancel";


/*
Renders a form for creating or editing a Trainer
 */
let TrainerCreator = ({
	trainer,
	cancel,
	execute,

	// admin rights
	isAdmin,
	licenseData,
	setTrainerPassword,
}) => {
	const [tempTrainer, updateTrainer] = useState({...trainer});

	// enter- and escape-handling
	const [submitRef, cancelRef, onKey, handleIf] = useSubmitCancel();


	// general inputs

	const onChange = ev => {
		ev.preventDefault();

		const {name, value} = ev.target;

		updateTrainer({
			...tempTrainer,
			[name]: value,
		});
	};

	const inputs = fields.map(f => makeInput(f, tempTrainer, onChange));

	// admin can change the license
	if (isAdmin) {
		const onChangeLicense = ev => {
			ev.preventDefault();

			// find the license with the given key
			const newLicense = licenseData.find(license => license.license === ev.target.value);

			updateTrainer({
				...tempTrainer,
				license: newLicense,
			});
		};

		inputs.push(makeLicenseSelection(licenseData, tempTrainer, onChangeLicense));
	}

	const onSubmit = ev => {
		const form = ev.currentTarget;
		ev.preventDefault();

		const valid = form.checkValidity();
		if (!valid)
			ev.stopPropagation();
		else {
			execute(tempTrainer);
		}
	};

	const onCancel = ev => {
		ev.preventDefault();
		cancel();
	};


	// admin can set the password
	const [showPasswordChanger, setShowPasswordChanger] = useState();
	const [password, setPassword] = useState();
	const [submitPasswordRef, cancelPasswordRef, onPasswordKey] = useSubmitCancel();
	const passwordRef = useRef();

	// dont handle enter/escape while the password changer is open
	useEffect(() => {
		if (setTrainerPassword)
			handleIf(ev => !showPasswordChanger);

		return () => {
			if (setTrainerPassword)
				handleIf();
		};
	}, []);

	let passwordChanger;
	if (setTrainerPassword) {
		let passwordPopup;
		if (showPasswordChanger) {
			const updatePassword = ev => {
				ev.preventDefault();
				setTrainerPassword(password);
				setPassword();
				setShowPasswordChanger(false);
			};

			const cancelChangePassword = () => {
				setShowPasswordChanger(false);
				setPassword();
			};

			passwordPopup = (
				<Modal
					show = {true}
					size = {'lg'}
					centered
					keyboard = {false}
					backdrop = {'static'}
					onEntered = {() => passwordRef.current.focus()}
					onHide = {cancelChangePassword}>
					<Modal.Header>
						<Modal.Title>
							{'Trainer-Passwort ändern'}
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<Container>
							<Row>
								<Col>
									<InputGroup>
										<InputGroup.Text>
											{'Neues Passwort'}
										</InputGroup.Text>
										<FormControl
											onKeyUp = {onPasswordKey}
											ref = {passwordRef}
											type = {'text'}
											required = {true}
											name = {'newPassword'}
											value = {password || ''}
											onChange = {ev => {
												ev.preventDefault();
												setPassword(ev.target.value);
											}}/>
									</InputGroup>
								</Col>
							</Row>
						</Container>
					</Modal.Body>
					<Modal.Footer>
						<Button className = {'mr-2'}
							ref = {submitPasswordRef}
							onClick = {updatePassword}
							disabled = {password === undefined || password.length === 0}>
							{'Passwort ändern'}
						</Button>
						<Button className = {'mt-1'}
							ref = {cancelPasswordRef}
							onClick = {cancelChangePassword}>
							{'Abbrechen'}
						</Button>
					</Modal.Footer>
				</Modal>
			);
		}

		passwordChanger = (
			<>
				<hr/>
				<Row className={'mt-2'}>
					<Col>
						<Button
							onClick = {ev => {
								ev.preventDefault();
								setShowPasswordChanger(true);
							}}>
							{'Trainer-Passwort ändern'}
						</Button>
					</Col>
				</Row>
				{passwordPopup}
			</>
		);
	}


	// render

	return (
		<>
			<Row>
				<Col>
					<Form
						onKeyUp = {onKey}
						noValidate
						validated = {true}
						onSubmit = {onSubmit}>
						{inputs}
						<Button className = {'mt-1 mr-2'}
							ref = {submitRef}
							onClick = {onSubmit}>
							{tempTrainer.id ? 'Übernehmen' : 'Anlegen'}
						</Button>
						<Button className = {'mt-1'}
							ref = {cancelRef}
							onClick = {onCancel}>
							{'Abbrechen'}
						</Button>
					</Form>
				</Col>
			</Row>
			{passwordChanger}
		</>
	);
};

export default TrainerCreator;
